import { GET_SAVED_SEARCH_EXPORT_PENDING } from '../actions/SavedSearchExportActions';

const initialState = {};

function SavedSearchExportReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SAVED_SEARCH_EXPORT_PENDING: {
      const { key, isPending } = action.payload;
      return { ...state, [key]: isPending };
    }

    default: {
      return state;
    }
  }
}

export default SavedSearchExportReducer;
